import { Box, Typography } from '@mui/material';
import { InfoIcon } from '../../assets/icons';
import { AppIcon } from '../../components/app-icon/AppIcon';

const InquiryPage: React.FC = () => {
  return (
    <Box sx={{ flex: 1, display: 'flex', alignItems: 'center', justifyContent: 'center', flexDirection: 'column' }}>
      <AppIcon Icon={InfoIcon} sx={{ height: '2rem', width: '2rem', mb: 2 }} />
      <Typography align="center">Select a conversation to view inquiries</Typography>
    </Box>
  );
};

export default InquiryPage;
